import { Checkbox, FormControlLabel } from '@material-ui/core';
import React, { ChangeEvent } from 'react';
import { CardTitle, Container } from './styles';

export interface IAcessModelValues {
    allResources: boolean,
    onlyRelatedToDirectory: boolean,
    onlyRelatedToOwner: boolean,
    onlyRelatedToModalities: boolean,
}

interface IGroupInfoCardProps {
    acessModelValues: {
        allResources: boolean,
        onlyRelatedToDirectory: boolean,
        onlyRelatedToOwner: boolean,
        onlyRelatedToModalities: boolean,
    }
    setAcessModelValues: React.Dispatch<React.SetStateAction<IAcessModelValues>>;
}

const GroupInfoCard: React.FC<IGroupInfoCardProps> = ({ acessModelValues, setAcessModelValues }) => {
    const handleChangeCheckboxes = (e: ChangeEvent<HTMLInputElement>) => {
        const {name, checked} = e.target;

        if(name === 'allResources') {
            setAcessModelValues({
                ...acessModelValues,
                ...(checked && {onlyRelatedToDirectory: false, onlyRelatedToOwner: false, onlyRelatedToModalities: false}),
                allResources: checked,
            });
        }else {
            setAcessModelValues({
                ...acessModelValues,
                ...(checked && {allResources: false}),
                [name]: checked,
            });
        }        
    }

    return (
        <Container>
            <CardTitle>Modelo de Acessos</CardTitle>

            <FormControlLabel
                control={
                    <Checkbox
                        value={acessModelValues.allResources}
                        checked={acessModelValues.allResources}
                        onChange={handleChangeCheckboxes}
                        name="allResources"
                        id="allResources"
                        color="primary"
                    />
                }
                label={'Acesso à todo conteúdo'}
            />

            <FormControlLabel
                control={
                    <Checkbox
                        value={acessModelValues.onlyRelatedToDirectory}
                        checked={acessModelValues.onlyRelatedToDirectory}
                        onChange={handleChangeCheckboxes}
                        name="onlyRelatedToDirectory"
                        id="onlyRelatedToDirectory"
                        color="primary"
                    />
                }
                label={'Acesso ao conteúdo relacionado à sua diretoria'}
            />

            <FormControlLabel
                control={
                    <Checkbox
                        value={acessModelValues.onlyRelatedToOwner}
                        checked={acessModelValues.onlyRelatedToOwner}
                        onChange={handleChangeCheckboxes}
                        name="onlyRelatedToOwner"
                        id="onlyRelatedToOwner"
                        color="primary"
                    />
                }
                label={'Acesso ao conteúdo se for responsável (criador, solicitante ou apresentador)'}
            />

            <FormControlLabel
                control={
                    <Checkbox
                        value={acessModelValues.onlyRelatedToModalities}
                        checked={acessModelValues.onlyRelatedToModalities}
                        onChange={handleChangeCheckboxes}
                        name="onlyRelatedToModalities"
                        id="onlyRelatedToModalities"
                        color="primary"
                    />
                }
                label={'Acesso ao conteúdo baseado nas modalidades'}
            />
        </Container>
    );
}

export default GroupInfoCard;
